<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <!-- rtu选择 -->
        <div class="label">选择站点：</div>
        <Select
          v-model="search.siteMn"
          style="width: 7.8em"
          @on-change="selectDevice($event)"
          placeholder="请选择设备"
          clearable
        >
          <Option v-for="item in siteList" :value="item.mn" :key="item.mn">{{ item.name }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px">选择设备：</div>
        <Select v-model="search.siteDeviceId" style="width: 7.8em;" placeholder="请选择设备" clearable>
          <Option v-for="item in deviceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <DatePicker
          type="daterange"
          placement="bottom-end"
          placeholder="选择日期"
          style="width: 200px;margin-left: 10px"
          @on-change="dateSelect($event)"
        ></DatePicker>
        <Select
          v-model="search.timeSegmentation"
          clearable
          style="width:100px;margin-left:10px;text-align:center;"
        >
          <Option
            v-for="item in timeSegmentationList"
            :key="item.value"
            :value="item.value"
          >{{ item.name }}</Option>
        </Select>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
      </div>
    </toolbar>
    <div class="chart_box">
      <v-chart autoresize :options="charts_temp" />
      <Spin fix v-show="loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
.chart_box {
  width: 100%;
  height: calc(100% - 7.5em);
  padding: 0 1em;
  position: relative;
}
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import ECharts from "vue-echarts";
import { fontSize } from "@/util/common/fontSize"; // 字体适配

export default {
  data() {
    return {
      charts_temp: {
        backgroundColor: "#293042",
        grid: {
          left: 10,
          top: "10%",
          bottom: 20,
          right: 40,
          containLabel: true
        },
        tooltip: {
          show: true,
          backgroundColor: "#384157",
          borderColor: "#384157",
          borderWidth: 1,
          formatter: "{b}:{c}",
          extraCssText: "box-shadow: 0 0 5px rgba(0, 0, 0, 1)"
        },
        legend: {
          right: 0,
          top: 0,
          data: ["距离"],
          textStyle: {
            color: "#5c6076"
          }
        },
        title: {
          text: "告警信息统计",
          x: "4.5%",
          top: "1%",
          textStyle: {
            color: "#5c6076"
          }
        },
        xAxis: {
          data: [],
          boundaryGap: false,
          axisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#5c6076"
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          ayisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#5c6076"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#2e3547"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#384157"
            }
          }
        },

        series: [
          {
            type: "bar",
            name: "linedemo",

            tooltip: {
              show: false
            },
            animation: false,
            barWidth: 1.4,
            hoverAnimation: false,
            data: [],
            itemStyle: {
              normal: {
                color: "#f17a52",
                opacity: 0.6,
                label: {
                  show: false
                }
              }
            }
          },

          {
            type: "line",
            name: "linedemo",
            smooth: true,
            symbolSize: 10,
            animation: false,
            lineWidth: 1.2,
            hoverAnimation: false,
            data: [10, 20, 30, 0],
            symbol: "circle",
            itemStyle: {
              normal: {
                color: "#f17a52",
                shadowBlur: 40,
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#f17a52"
                  }
                }
              }
            },
            areaStyle: {
              normal: {
                color: "#f17a52",
                opacity: 0.08
              }
            }
          }
        ]
      },
      // 查询
      search: {
        siteMn: null,
        siteDeviceId: null,
        startDate: new Date().setHours("0"),
        endDate: new Date().getTime(),
        timeSegmentation: null
      },
      siteList: [], // 站点枚举列表
      deviceList: [], // 设备枚举
      timeSegmentationList: [
        {
          name: "每分钟",
          value: 60
        },
        {
          name: "每十分钟",
          value: 600
        },
        {
          name: "每小时",
          value: 3600
        }
      ],
      // 图表 loading
      loading: true
    };
  },
  components: {
    toolbar
  },
  created() {
    this.getSiteList(); // 获取站点枚举
    this.getData();
  },
  methods: {
    getData() {
      // 获取数据
      this.loading = true;
      this.$api.Warn.getWarnChartAi(
        {
          content: this.search
        },
        ["uuid", "company"]
      )
        .then(res => {
          if (res.code == 0) {
            // 获取成功
            this.loading = false;
            let warnData = res.data["告警"]; // 告警数据
            for (let i = 0, length = res.data["停机"].length; i < length; i++) {
              warnData.push(res.data["停机"][i]);
            }
            warnData.sort(function(a, b) {
              return (
                Date.parse(b.date.replace(/-/g, "/")) -
                Date.parse(a.date.replace(/-/g, "/"))
              );
            });
            let dateList = []; // 时间
            let dataList = []; // 数据值
            warnData.map(res => {
              dateList.push(res.date);
              dataList.push(res.count);
            });
            this.charts_temp.xAxis.data = dateList;
            this.charts_temp.series[0].data = dataList;
            this.charts_temp.series[1].data = dataList;
            this.$Message.success("加载完成");
          } else {
            this.loading = false;
            this.$Message.warning(res.message);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$Notice.warning({
            title: "获取汇总信息失败",
            desc: err || "请联系管理员"
          });
        });
    },
    // 获取站点枚举值
    getSiteList() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取站点枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取设备
    selectDevice(msg) {
      this.$api.Enum.getDeviceEnum({ content: { mn: msg } }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0) {
          this.deviceList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取端口对应设备失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    // 搜索
    searchFunc() {
      this.getData();
    }
  }
};
</script>